import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import i18n from '@/utils/i18n';
import { adminInfoStoreQuery } from '../../graphql/queries';
import { useMutation, useQuery } from '@apollo/client';
import { createVendingMachineMutation } from '../../graphql/mutations';
import { Button } from 'reactstrap';
import { FaPlus } from 'react-icons/fa';
import { Communicator } from '../../tools/Communication';
import { ContentSection } from '../../components/Layout/ContentSection';

type VendingMachineTabProps = {
  pickpackStoreId: string;
  title: string;
};

export const VendingMachineTab = (props: VendingMachineTabProps) => {
  const intialState = {
    store: {
      id: '',
      name: 'vnd',
      external_vytal_id: '',
      vending_machines: [],
    },
  };
  const [createVendingMachine] = useMutation(createVendingMachineMutation);
  const { data = intialState, loading } = useQuery(adminInfoStoreQuery, {
    variables: { id: props.pickpackStoreId },
  });
  const { store } = data;

  async function addVendingMachine() {
    try {
      const response = await Communicator.Get('/Merchant/GetApiKeyInfo', {
        storeId: encodeURIComponent(store.external_vytal_id),
      });
      const apiKeyData = await response.json();

      createVendingMachine({
        variables: {
          store_id: props.pickpackStoreId,
          user_id: apiKeyData.defaultStockUserId,
          api_key: apiKeyData.apiKey,
        },
        refetchQueries: [
          {
            query: adminInfoStoreQuery,
            variables: {
              id: props.pickpackStoreId,
            },
          },
        ],
      });
    } catch (error) {
      alert(i18n.t('MerchantOrder:alertNoAppAccounts'));
    }
  }

  const header = (
    <div className="align-items-center export-buttons flex">
      <Button
        type="button"
        onClick={addVendingMachine}
        className="me-2"
        data-pr-tooltip={i18n.t('VendingMachine:addVendingMachine')}
      >
        <FaPlus />
      </Button>
    </div>
  );

  return (
    <ContentSection title={props.title} collapsable={false} key="content">
      <DataTable
        header={header}
        value={store.vending_machines || []}
        dataKey="id"
        responsiveLayout="scroll"
        lazy
        loading={loading}
        className="p-datatable-striped"
        style={{ width: '100%', overflowX: 'scroll' }}
      >
        <Column
          headerStyle={{ width: '200px' }}
          body={(vnd: any) => (
            <a href={`/vending-machine/${store.id}/${vnd.id}`}>{vnd.name}</a>
          )}
          header={i18n.t('Common:name')}
        />
      </DataTable>
    </ContentSection>
  );
};
